import { render, staticRenderFns } from "./InputCheckBox.vue?vue&type=template&id=1b673a3e"
import script from "./InputCheckBox.vue?vue&type=script&lang=js"
export * from "./InputCheckBox.vue?vue&type=script&lang=js"
import style0 from "./InputCheckBox.vue?vue&type=style&index=0&id=1b673a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports